export default {
	description: 'See 100s of premium vehicles available to buy now.',
	fullDescription: '{mileage} miles | {fuel} | {transmission}. See full spec & photos »',
	title: 'Vehicles For Sale | Motorway',
};
